export default __webpack_public_path__ + "static/media/34_MagicTree.20cbc010.JPG";